import {
  Page,
  PageHeader,
  PageHeaderTitle,
  PageBody,
  PageHeaderDescription,
  Link,
} from '@customerio/pluma-components/react';
import { Helmet } from 'react-helmet-async';
import { TasksTable } from '@/features/tasks';

export default function Tasks() {
  return (
    <>
      <Helmet>
        <title>Tasks | Customer.io</title>
      </Helmet>
      <Page w="full">
        <PageHeader>
          <PageHeaderTitle>Tasks</PageHeaderTitle>
          <PageHeaderDescription>
            Monitor background tasks, like segment creation and imports, across your workspace.{' '}
            <Link
              href="https://docs.customer.io/accounts-and-workspaces/workspace-tasks/"
              isExternal
              variant="secondary"
            >
              Learn more
            </Link>
          </PageHeaderDescription>
        </PageHeader>
        <PageBody>
          <TasksTable />
        </PageBody>
      </Page>
    </>
  );
}
